
const validateNumber = (_, value) => {
  const reg = /^[\u4e00-\u9fa5]$/
  return !value || reg.test(value) ? Promise.reject('不能输入中文') : Promise.resolve()
}

const validatePhone = (_, value) => {
  const reg = /^1[3-9]\d{9}$/
  return !value || reg.test(value) ? Promise.resolve() : Promise.reject('手机号格式不对')
}

const validatLength = (_, value) => {
  const reg = /^.{0,30}$/
  return !value || reg.test(value) ? Promise.resolve() : Promise.reject('最大字符长度为30')
}

const validatLength2 = (_, value) => {
  const reg = /^.{0,50}$/
  return !value || reg.test(value) ? Promise.resolve() : Promise.reject('最大字符长度为50')
}

const validateUser = (_, value) => {
  value = value.trim()
  const reg = /^[A-Za-z0-9]{3,20}$/
  return reg.test(value) ? Promise.resolve() : Promise.reject('用户名由3-20位数字,字母或其组合组成')
}
const validate = (_, value) => {
  const reg = /^\d+(\.\d+)?$/
  return !value || reg.test(value) ? Promise.resolve() : Promise.reject('只能输入非负浮点数')
}
export { validateNumber, validatePhone, validatLength, validatLength2, validateUser, validate } 